import { render, staticRenderFns } from "./ModalBillDetails.vue?vue&type=template&id=efacf8bc&scoped=true"
import script from "./ModalBillDetails.vue?vue&type=script&lang=js"
export * from "./ModalBillDetails.vue?vue&type=script&lang=js"
import style0 from "./ModalBillDetails.vue?vue&type=style&index=0&id=efacf8bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efacf8bc",
  null
  
)

export default component.exports